/**
 * Числа и согласование слов по-русски — одни на всю админку.
 *
 * В ките, а не в модуле: до выноса склонение жило четырьмя копиями
 * (`conversations/use-bulk-action.ts`, `chargebacks/list.tsx`,
 * `ui-domain/whale-badge.tsx`, `content/format.ts`), а `Intl.NumberFormat('ru-RU')`
 * — ещё в трёх модулях. Лежит в `ui`, а не в `ui-domain`: это язык, не домен,
 * и счётчик символов `ui-forms` (`TextareaWidget`, `meta.showCount`) тоже им
 * пользуется, а `ui-forms` зависит только от `ui`.
 *
 * Без React и без зависимостей — поэтому есть и отдельный вход
 * `@wit-support/ui/format`: чистое ядро (например, `graph/` конструктора
 * пайплайнов) берёт склонение оттуда, не втягивая React-кит. Корень
 * `@wit-support/ui` по-прежнему реэкспортирует всё отсюда.
 */
const NUMBER_FORMATS = new Map();
/**
 * Число с русскими разделителями: «12 300», «2,9». Форматтер кешируется по
 * опциям — ячейки таблиц зовут функцию на каждой строке.
 */
export function formatNumberRu(value, options = {}) {
    const key = String(options.maximumFractionDigits ?? '');
    let fmt = NUMBER_FORMATS.get(key);
    if (!fmt) {
        fmt = new Intl.NumberFormat('ru-RU', options.maximumFractionDigits === undefined
            ? undefined
            : { maximumFractionDigits: options.maximumFractionDigits });
        NUMBER_FORMATS.set(key, fmt);
    }
    return fmt.format(value);
}
/** Русская форма слова для числа: «1 ролик», «3 ролика», «5 роликов», «11 роликов». */
export function pluralRu(n, forms) {
    const abs = Math.abs(Math.trunc(n));
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (mod10 === 1 && mod100 !== 11)
        return forms[0];
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return forms[1];
    return forms[2];
}
/**
 * Число с единицей: «12 300 просмотров». `null`/`undefined`/не число — «—»:
 * так ячейка таблицы показывает «нет данных», а не «NaN просмотров».
 */
export function formatCount(n, forms) {
    if (n === null || n === undefined || !Number.isFinite(n))
        return '—';
    return `${formatNumberRu(n, { maximumFractionDigits: 0 })} ${pluralRu(n, forms)}`;
}
//# sourceMappingURL=format-number.js.map